import { render, staticRenderFns } from "./VideoBox.vue?vue&type=template&id=7b094836&scoped=true"
import script from "./VideoBox.vue?vue&type=script&lang=js"
export * from "./VideoBox.vue?vue&type=script&lang=js"
import style0 from "./VideoBox.vue?vue&type=style&index=0&id=7b094836&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b094836",
  null
  
)

export default component.exports